import set from "lodash/set";

import type { Column, GridApi } from "ag-grid-community";

/** Mutate __collapsedSiblings on a row node. */
export function writeCollapsedSiblings(
  node: { data: Record<string, unknown> },
  columnField: string,
  entries: [string, unknown][],
): void {
  let prev =
    (node.data.__collapsedSiblings as
      | Record<string, Record<string, unknown>>
      | undefined) ?? {};

  for (const [key, value] of entries) {
    prev = { ...prev, [key]: { ...prev[key], [columnField]: value } };
  }

  node.data.__collapsedSiblings = prev;
}

/**
 * Write a sibling row's value in the current column, by benefitKey. `silent`
 * updates bypass `setDataValue` — callers should silently write every sibling
 * except the one that triggers the save, so all `__collapsedSiblings` land in
 * one PATCH instead of one per sibling with stale, partial data.
 */
export function writeSibling(
  props: {
    api: GridApi;
    column?: Column | string;
    colDef?: { field?: string };
  },
  benefitKey: string,
  value: unknown,
  options?: { silent?: boolean },
): void {
  const colKey = props.column ?? props.colDef?.field;
  if (!colKey) return;
  const colId = typeof colKey === "string" ? colKey : colKey.getColId();

  props.api.forEachNode((n) => {
    if (n.data?.benefitKey === benefitKey) {
      if (options?.silent) {
        const data = n.data as { benefit?: { networkDependent?: boolean } };
        const path =
          data.benefit?.networkDependent === true || !colId.includes(".")
            ? colId
            : colId.split(".")[0];
        set(n.data, path, value);
      } else {
        n.setDataValue(colKey, value);
      }
    }
  });
}
